import { render, staticRenderFns } from "./CustomerCourseForm.vue?vue&type=template&id=fe5a2438&scoped=true&"
import script from "./CustomerCourseForm.vue?vue&type=script&lang=js&"
export * from "./CustomerCourseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5a2438",
  null
  
)

export default component.exports